exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".r-field{margin-top:10px;margin-bottom:5px}.r-field div{width:100%;text-align:right;font-size:12px}.r-field div.required{color:red}.r-field input,.r-field select,.r-field textarea{width:100%;height:25px;font-size:12px}.r-field textarea{height:60px}.r-button{background:#b8e986;width:32px;height:32px;border-radius:50px;text-align:center;box-shadow:0 4px 4px #888;border:0}.r-button i{font-size:24px;position:relative;left:-2px;padding-top:1px;color:#fff}.split{margin-top:5px;margin-bottom:5px}.radio-list{list-style-type:none;padding:0 0 0 10px;border:1px solid #ccc;margin:0 0 20px;max-height:300px;overflow:scroll}.radio-list li{margin:0;padding:0}.radio-list input{width:20px}.radio-list label{font-weight:400;position:relative;font-size:12px;top:-5px;margin-left:10px}.kmz-edit{color:#4d88d6;background:#fff;border:1px solid #4d88d6;width:100%;margin-top:10px;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/styles/_forms.less
// module id = 906
// module chunks = 0